import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrdersPage } from '@/features/orders/components/OrdersPage';

const ordersSearchSchema = z.object({
  productLabel: z.string().optional(),
});

export const Route = createFileRoute('/$commiteeSlug/orders/')({
  component: RouteComponent,
  validateSearch: (search) => ordersSearchSchema.parse(search),
});

function RouteComponent() {
  const { productLabel } = Route.useSearch();
  return <OrdersPage initialProductLabelFilter={productLabel} />;
}
